import { ResponsiveBar } from '@nivo/bar';
import { nivoTheme } from '@shared/ui/nivoTheme';

export interface CpmRow { handle: string; cpm: number; color: string }

// One horizontal bar per creator = their cost per 1000 real reel views, with a dashed
// reference line at the market CPM. Cheapest-per-view at the top; bars coloured by verdict.
export default function PriceCpmChart({ rows, market, marketLabel }: { rows: CpmRow[]; market: number; marketLabel: string }) {
  const data = [...rows].sort((a, b) => b.cpm - a.cpm); // Nivo horizontal draws data[0] at bottom → worst bottom, best top
  const maxX = Math.max(market, ...rows.map((r) => r.cpm)) * 1.14;

  const MarketLine = ({ xScale, innerHeight }: { xScale: (v: number) => number; innerHeight: number }) => {
    const x = xScale(market);
    return (
      <g>
        <line x1={x} x2={x} y1={-6} y2={innerHeight} stroke="#e6c84a" strokeDasharray="4 4" strokeWidth={1.5} />
        <text x={x} y={-10} fill="#e6c84a" fontSize={10} textAnchor="middle">{marketLabel}</text>
      </g>
    );
  };

  return (
    <div style={{ height: Math.max(130, data.length * 40 + 46) }}>
      <ResponsiveBar
        data={data as unknown as Record<string, string | number>[]}
        keys={['cpm']}
        indexBy="handle"
        layout="horizontal"
        margin={{ top: 18, right: 26, bottom: 30, left: 140 }}
        valueScale={{ type: 'linear', min: 0, max: Math.round(maxX) }}
        padding={0.34}
        colors={(b: { data: Record<string, unknown> }) => (b.data as unknown as CpmRow).color}
        borderRadius={3}
        enableGridX
        enableGridY={false}
        axisBottom={{ tickSize: 0, tickPadding: 6 }}
        axisLeft={{ tickSize: 0, tickPadding: 8 }}
        label={(d: { value: number | null }) => String(Math.round(Number(d.value)))}
        labelTextColor="#dde"
        theme={nivoTheme}
        layers={['grid', 'axes', 'bars', MarketLine as never, 'markers']}
        role="img"
        ariaLabel="CPM vs market"
      />
    </div>
  );
}
